<template>
  <collapsible-widget
    title="KOMPOZYCJE"
    :maxHeight="30"
    :expand-widget="$store.getters.compositionLayersExpanded"
    :accordion="accordion"
    ref="collapsible"
    :default-expanded="$store.getters.compositionLayersExpanded"
  >
    <b-list-group id="compositions-list">
      <div v-if="layersLoading">
        <spinner class="layers-loading" :loading="true"></spinner>
      </div>
      <compositions-branch
        v-else
        v-for="compositionsBranch in compositionItems"
        :key="compositionsBranch.id"
        :compositions-branch="compositionsBranch"
        v-model="compositionsBranch.active"
      />
    </b-list-group>
  </collapsible-widget>
</template>

<script>
import { mapGetters } from 'vuex';
import {} from '../store/actions.type';
import Spinner from './Spinner';
import { COMPOSITIONS_SET } from '../store/mutations.type';
import CompositionsBranch from './CompositionsBranch.vue';
import CollapsibleWidget from './CollapsibleWidget';

export default {
  name: 'Compositions',
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: { Spinner, CollapsibleWidget, CompositionsBranch },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['compositions', 'layersLoading']),
    compositionItems: {
      get() {
        return this.compositions;
      },
      set(value) {
        this.$store.commit(COMPOSITIONS_SET, value);
      }
    }
  },
  methods: {
    toggleItemCollapse(item) {
      item.expandWidget = !item.expandWidget;
    }
  }
};
</script>

<style>
#compositions-list .composition-name {
  overflow: hidden;
  word-wrap: break-word;
  width: 100%;
}

.composition-header {
  border: none !important;
  padding-right: 0 !important;
  padding-left: 1em !important;
  cursor: pointer !important;
}

.composition-header.active {
  background: none !important;
  border: none !important;
  color: inherit !important;
}

.composition-expandable-list-item.active {
  z-index: 1;
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  border-bottom: 2px solid rgba(0, 0, 0, 0.125);
}

.composition-layers-collapse .layers-list-group-item {
  font-size: 0.875em;
  padding-left: 20px;
}

.composition-layers-collapse .layer-expander {
  margin-left: 0;
}

.eye-icon {
  height: 1rem;
  cursor: default;
}

.composition-expandable-list-item .eye-icon,
.composition-expandable-list-item .more-icon {
  -webkit-transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  -moz-transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  -o-transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  opacity: 0;
}

.composition-expandable-list-item.active .eye-icon,
.composition-expandable-list-item.active .more-icon {
  -webkit-transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  -moz-transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  -o-transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  opacity: 1;
}

.composition-expandable-list-item .inline-custom-checkbox {
  -webkit-transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  -moz-transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  -o-transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  transition: all 200ms cubic-bezier(0.4, 0, 1, 1);
  padding-left: 0;
  opacity: 0;
}

.composition-expandable-list-item.active .inline-custom-checkbox {
  -webkit-transition: all 250ms cubic-bezier(0, 0, 0.2, 1);
  -moz-transition: all 250ms cubic-bezier(0, 0, 0.2, 1);
  -o-transition: all 250ms cubic-bezier(0, 0, 0.2, 1);
  transition: all 250ms cubic-bezier(0, 0, 0.2, 1);
  padding-left: 24px;
  opacity: 1;
}

.more-dropdown > .btn {
  background: transparent;
  border: none;
  color: #007bff;
  padding-left: 0.5em;
  padding-right: 0.5em;
  padding-top: 0;
  padding-bottom: 0;
  box-shadow: none;
}

.composition-layer-dropdown-item span {
  margin-left: 1em;
}

@keyframes saveTransform {
  50% {
    transform: scale(1.5);
  }
}

.composition-layer-dropdown-item > button:hover > .zoom-animation {
  animation: saveTransform 500ms;
}

@keyframes rotate {
  100% {
    transform: rotate(-360deg);
  }
}

.composition-layer-dropdown-item > button:hover > .rotate-animation {
  animation: rotate 500ms;
}

.composition-loading-progress {
  visibility: hidden;
  width: 0%;
}

.composition-loading-progress.loading {
  margin-top: 0.5em;
  margin-right: 0.5em;
  visibility: visible;
  width: calc(100% - 0.5em);
  transition: width 200ms;
}
.composition-item-btn {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  width: 100%;
}
.collapsible-widget-body {
  background-color: rgba(255, 255, 255, 0.85);
  margin-bottom: 0;
  display: block;
}
</style>
